import { DataProcessingTab, dataProcessingTabFromQuery, dataProcessingTabToQuery, DataProcessingViewAccess } from "./DataProcessing.types";

const viewStorageKey = "data-processing-view";

export function rememberDataProcessingTab(tab: DataProcessingTab) {
    localStorage.setItem(viewStorageKey, dataProcessingTabToQuery(tab));
}

// The nav menu links straight to the view the user last had open, so leaving for another menu item and coming
// back lands where they left off.
export function readRememberedDataProcessingTab(): DataProcessingTab {
    return dataProcessingTabFromQuery(localStorage.getItem(viewStorageKey));
}

// A view can be asked for by a user who may not open it, e.g. a remembered record or transfers view after the
// permission was taken away, or a remembered statistics view after the research module was removed, so it falls back to the
// processing activities, which everyone reaching the page can open.
export function resolveDataProcessingTab(requestedTab: DataProcessingTab, access: DataProcessingViewAccess): DataProcessingTab {
    if (canOpenDataProcessingTab(requestedTab, access)) {
        return requestedTab;
    }

    return DataProcessingTab.ProcessingActivities;
}

function canOpenDataProcessingTab(tab: DataProcessingTab, access: DataProcessingViewAccess): boolean {
    switch (tab) {
        case DataProcessingTab.Transfers:
            return access.canAccessTransfers;
        case DataProcessingTab.Record:
            return access.canAccessRecord;
        case DataProcessingTab.Statistics:
            return access.canAccessStatistic;
        default:
            return true;
    }
}
